/**
 * Response - A query response object that contains pagination, results, and
 * optional top-level metadata from the API response.
 */
export default class Response {
  /**
   * Response constructor
   * @param {int} totalEntries - Total number of entries based on per_page
   * @param {int} totalPages - Total number of pages based on per_page
   * @param {int} previousPage - Previous page
   * @param {int} nextPage - Next page
   * @param {Array} results - Results from the API call
   * @param {Object} meta - Additional top-level response metadata
   */
  constructor(totalEntries, totalPages, previousPage, nextPage, results, meta = {}) {
    this.totalEntries = totalEntries;
    this.total_entries = totalEntries;

    this.totalPages = totalPages;
    this.total_pages = totalPages;

    this.previousPage = previousPage;
    this.previous_page = previousPage;

    this.nextPage = nextPage;
    this.next_page = nextPage;

    this.results = results || [];
    this.meta = meta || {};
  }
}
